"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnIntegVer = void 0;
const base_1 = require("./base");
const ver_1 = require("../services/ver");
/**
 * Verizon
 */
class AnIntegVer extends base_1.AnIntegBase {
    static isLoaded() {
        return ver_1.AnServVer.isLoaded();
    }
    static sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon) {
        ver_1.AnServVer.sendCustEventP(this.getPixelId(siteCategory).split("||")[1], this.getPixelId(siteCategory).split("||")[0], {
            et: "custom",
            ea: "Purchase",
            gv: price.toString(),
        });
        return true;
    }
    static sendTrackClubThankyouLegacy(siteCategory, userId, email, price, style, color, coupon) {
        return this.sendTrackClubThankyou(siteCategory, userId, email, price, style, color, coupon);
    }
}
exports.AnIntegVer = AnIntegVer;
AnIntegVer.shouldSendTrackClubThankyou = true;
AnIntegVer.shouldSendTrackClubThankyouLegacy = true;
AnIntegVer.pixelId = {
    prod: {
        defaultId: "10000||10145694",
        ecomm: null,
        club: null,
    },
    dev: {
        defaultId: "10000||10145694",
        ecomm: null,
        club: null,
    },
};
